import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';

// Tipos
export type Turma = {
  id: number;
  nome: string;
  sigla: string;
};

export type Turno = {
  id: number;
  nome: string;
};

export type Serie = {
  id: number;
  nome: string;
  curso: string;
  turno: string;
  turma: string;
  periodo: string;
};

async function listTurmas(nome?: string): Promise<Turma[]> {
  const api = await getApi();
  const { data } = await api.get('/crm/lista-turmas/', {
    params: nome ? { nome } : undefined
  });
  return data;
}

async function listTurnos(nome?: string): Promise<Turno[]> {
  const api = await getApi();
  const { data } = await api.get('/crm/lista-turnos/', {
    params: nome ? { nome } : undefined
  });
  return data;
}

async function listSeries(filters?: {
  serie_nome?: string;
  turma?: string;
  turno?: string;
}): Promise<Serie[]> {
  const api = await getApi();
  const { data } = await api.get('/crm/lista-serie/', {
    params: filters
  });
  return data;
}

// Hooks
export function useTurmas(nome?: string) {
  return useQuery({
    queryKey: ['crm-turmas', nome],
    queryFn: () => listTurmas(nome),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

export function useTurnos(nome?: string) {
  return useQuery({
    queryKey: ['crm-turnos', nome],
    queryFn: () => listTurnos(nome),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}

export function useSeries(filters?: {
  serie_nome?: string;
  turma?: string;
  turno?: string;
}) {
  return useQuery({
    queryKey: ['crm-series', filters],
    queryFn: () => listSeries(filters),
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}
